import Axios from '../../config/axios';

const API_BASE_URL = '/api/patients';

export const medicalHistoryService = {
    // Get medical history for a patient
    async getMedicalHistory(patientId) {
        try {
            const response = await Axios.get(`${API_BASE_URL}/${patientId}/medical-history`);
            return response.data;
        } catch (error) {
            console.error('Error fetching medical history:', error);
            throw new Error('Failed to load medical history');
        }
    },

    async checkExamAddAttributes(patientId) {
        try {
            const response = await Axios.get(`${API_BASE_URL}/${patientId}/medical-history/check-exam-add-attributes`);
            return response.data;
        } catch (error) {
            console.error('Error checking exam add attributes:', error);
            throw new Error('Failed to check exam add attributes');
        }
    },

    // Update medical history for a patient
    async updateMedicalHistory(patientId, medicalHistory) {
        try {
            const response = await Axios.post(`${API_BASE_URL}/${patientId}/medical-history`, medicalHistory);
            return response.data;
        } catch (error) {
            console.error('Error updating medical history:', error);
            throw new Error('Failed to save medical history');
        }
    }
};